import { supabase } from '@/integrations/supabase/client';

export class BriefBulletsSkandiNaviaService {
  static async triggerPublication() {
    try {
      const { data, error } = await supabase.functions.invoke(
        'publish-briefr-bullets-skandinavia',
        {
          body: { manual: true }
        }
      );

      if (error) throw error;
      return { success: true, data };
    } catch (error) {
      console.error('Error triggering Skandinavia publication:', error);
      throw error;
    }
  }

  static async getTaskStatus() {
    try {
      const { data, error } = await supabase
        .from('scheduled_tasks')
        .select('*')
        .eq('task_type', 'briefr_bullets_skandinavia')
        .single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error fetching Skandinavia task status:', error);
      throw error;
    }
  }

  static async getTaskLogs() {
    try {
      const { data, error } = await supabase
        .from('task_logs')
        .select('*')
        .eq('task_type', 'briefr_bullets_skandinavia')
        .order('created_at', { ascending: false })
        .limit(10);

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error fetching Skandinavia task logs:', error);
      throw error;
    }
  }

  static async updatePhotoUrl(photoUrl: string) {
    try {
      const { error } = await supabase
        .from('scheduled_tasks')
        .update({
          config: { photo_url: photoUrl }
        })
        .eq('task_type', 'briefr_bullets_skandinavia');

      if (error) throw error;
      return { success: true };
    } catch (error) {
      console.error('Error updating Skandinavia photo URL:', error);
      throw error;
    }
  }

  static async toggleAutomaticPublishing(enable: boolean): Promise<boolean> {
    try {
      const { error } = await supabase
        .from('scheduled_tasks')
        .update({
          status: enable ? 'active' : 'paused',
        })
        .eq('task_type', 'briefr_bullets_skandinavia');

      if (error) {
        console.error('Error toggling automatic publishing:', error);
        return false;
      }

      return true;
    } catch (error) {
      console.error('Error toggling automatic publishing:', error);
      return false;
    }
  }
}
